import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPropertyIdDocumentsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyDocumentsQuery = (id?: number) => {
	return useQuery({
		queryKey: PortfolioKeys.propertyDocuments(id ?? null),
		queryFn: processResponse(() => getPropertyIdDocumentsV2(id!)),
		enabled: Boolean(id),
	});
};
